module.exports = __webpack_public_path__ + "img/39.99e83061.jpg";